import { JourneyItemStateInterface } from '@context/reducers';

export function openCompanyEvaluating(id: JourneyItemStateInterface['id']) {
  window.localStorage.setItem('companyEvaluating_evaluating', 'open');
  window.dispatchEvent(new Event('companyEvaluating_toggleEvaluating'));
  window.localStorage.setItem('companyEvaluating_travelId', id || '');
}

export function OpenRateDriver(journeyId: string) {
  window.localStorage.setItem('companyEvaluating_toggleDenounce', 'open');
  window.localStorage.setItem('companyEvaluating_travelId', journeyId);
  window.dispatchEvent(new Event('companyEvaluating_toggleCreateDenounce'));
}
